import { Helmet } from 'react-helmet-async';
import { withResourceProtection } from 'app/components/ReusableUIComponents/HOCs/ResourceProtected/withResourceProtection';
import { MetricsFrameworkProvider } from './context/MetricsFrameworkContext';
import { MetricDrilldownProvider } from './context/MetricDrilldownContext';
import MetricsFrameworkPageContent from './components/MetricsFrameworkPageContent';
import { IMPACT_HUB_BASE_PATH } from './utils/viewConfig';

const ImpactHubPageBase = () => (
  <MetricsFrameworkProvider>
    <MetricDrilldownProvider>
      <Helmet>
        <title>Impact Hub</title>
        <meta
          name="description"
          content="Impact Hub - dealer nurturing and sales impact reporting"
        />
      </Helmet>
      <MetricsFrameworkPageContent />
    </MetricDrilldownProvider>
  </MetricsFrameworkProvider>
);

const ImpactHubPage = withResourceProtection(
  ImpactHubPageBase,
  IMPACT_HUB_BASE_PATH,
);

export default ImpactHubPage;

/** Alias for AI-avatar resource_mappings — same shared `/impact-hub` page. */
export const AIAvatarImpactHubPage = ImpactHubPage;

/** Legacy aliases for older resource_mappings. */
export const MetricsFrameworkPage = ImpactHubPage;
export const AIAvatarMetricsFrameworkPage = ImpactHubPage;
